import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { errorsModels } from './http-errors.models';
import { ToasterService } from '@auto-editor/feature-toaster';
// import { ToasterService } from '@nx-ratenow/core/feature-notifications';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorsService {
  errorsModels = errorsModels;
  constructor(private toastrService: ToasterService) {}

  catchError(httpErrorResponse: HttpErrorResponse) {
    this.toastrService.error(this.getErrorMessage(this.getErrorReason(httpErrorResponse).reason));
  }

  getErrorReason(httpErrorResponse: HttpErrorResponse) {
    return httpErrorResponse.error.errors ? httpErrorResponse.error.errors[0] : httpErrorResponse.error;
  }

  /** check if http error has BE format  */
  public _isInstanceOfClientError(object: any): boolean {
    const commonKeys: string[] = ['error', 'error_description'];
    let isInstance = true;

    if (object) {
      Object.keys(object).map((v) => {
        isInstance = isInstance && commonKeys.indexOf(v) > -1;
      });
    }

    return isInstance;
  }

  public getErrorMessage(reason: string): string {
    console.log(reason);
    return errorsModels.has(reason) ? (errorsModels.get(reason) as string) : 'error-notification.default';
  }
}
